import { z } from 'zod';

/**
 * Blocos da Home que podem ser ligados e desligados por usuario.
 *
 * Sao diferentes de TELA: a tela e um lugar aonde se vai, o bloco e um pedaco
 * de uma tela que a pessoa ja acessa. Quem so acompanha despesa nao precisa ver
 * quantos lancamentos faltam classificar — isso e trabalho de outra pessoa, e
 * um numero grande de pendencias na tela de quem nao classifica so gera
 * pergunta sem dono.
 *
 * O catalogo vive aqui, e nao em cada lado, para as caixas de selecao do
 * cadastro e a montagem da Home nunca discordarem sobre o que existe.
 *
 * `resultado` e `entradas` tem corte no SERVIDOR, e nao so na tela: quanto a
 * empresa fatura nao e informacao que se esconde com um `display: none`. Sem o
 * bloco, os campos nem saem da API — nao ha o que abrir no inspetor.
 */
export const BLOCOS = [
  {
    key: 'resultado',
    label: 'Receita, despesa e resultado',
    description: 'Entradas, saidas e o que sobrou no periodo.',
  },
  {
    key: 'entradas',
    label: 'Análise de entradas',
    description: 'Volatilidade, padrao de recebimento no mes e ticket medio.',
  },
  {
    key: 'pendentes',
    label: 'Pendentes de classificação',
    description: 'Quantos lancamentos ainda nao tem categoria.',
  },
  {
    key: 'competencias',
    label: 'Competências importadas',
    description: 'Quantos meses ja tem extrato no sistema.',
  },
  {
    key: 'periodos_fechados',
    label: 'Períodos fechados',
    description: 'Quantas competencias estao travadas para alteracao.',
  },
] as const;

export type BlocoKey = (typeof BLOCOS)[number]['key'];

export const BLOCO_KEYS: readonly BlocoKey[] = BLOCOS.map((bloco) => bloco.key);

export const blocoKey = z.enum(BLOCO_KEYS as unknown as [BlocoKey, ...BlocoKey[]]);

/**
 * Blocos de um usuario novo: todos.
 *
 * O padrao de um controle de visibilidade deve ser o que a maioria precisa,
 * para esconder ser um ato deliberado e visivel — e nao um esquecimento que
 * deixa alguem sem informacao sem ninguem perceber.
 */
export const BLOCOS_PADRAO: readonly BlocoKey[] = BLOCO_KEYS;

/** Admin vê tudo: é quem configura a visibilidade dos outros. */
export function blocosDoUsuario(role: string, liberados: readonly string[]): BlocoKey[] {
  if (role === 'admin') return [...BLOCO_KEYS];
  return BLOCO_KEYS.filter((key) => liberados.includes(key));
}
